import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MainRouter } from './core/routes'
import { MainAppRender } from '@reapitform/core'
import { ReapitConnectSessionProvider } from '@reapitform/hooks'

import '@reapit/elements/reset.css'
import '@reapit/elements/dist/index.css'
import '@reapitform/dashboard-ui/dist/index.css'
import '@reapitform/common-ui/dist/index.css'
import '@reapitform/utils/dist/index.css'
import { reapitConnectBrowserSession } from './core/reapit-connect-session'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MainAppRender>
      <ReapitConnectSessionProvider reapitConnectSession={reapitConnectBrowserSession}>
        <MainRouter />
      </ReapitConnectSessionProvider>
    </MainAppRender>
  </StrictMode>,
)
